<div class="container-fluid">
  <div class="card" id="s1">
    <div class="card-header pb-0">
      <div class="media">
        <h4>{{ "admin.campaigns.pipeline.title" | translate }}</h4>

        <div class="media-body text-end">
          <div class="d-inline-flex">
            <app-date-range-picker
              [form]="formFilter | asFormGroup"
              inputFormControlName="date"
            ></app-date-range-picker>
            <app-search-field
              class="ms-2"
              [form]="formFilter | asFormGroup"
              [filterOptions]="filterAds"
              [placeholder]="'placeholder.searchByCampaignTitle' | translate"
              inputFormControlName="title"
              (emitSelectedOptions)="saveOption($event)"
            ></app-search-field>
            <button
              class="btn btn-primary me-3 ms-3"
              type="button"
              (click)="createAdvertisingCampaign()"
            >
              <i class="icon-plus"></i>
              {{ "buttons.createCampaign" | translate }}
            </button>
            <div>
              <app-refresh-button
                [state]="fetchingCampaignState"
                [date]="cachedAt"
                (buttonClick)="refreshCampaigns(true)"
              ></app-refresh-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card-body">
      <div class="table-responsive data-table">
        <form>
          <table
            class="table table-striped table-border-vertical"
            id="announcersTable"
          >
            <thead>
              <tr>
                <ng-container *ngFor="let column of columns">
                  <th
                    class="h-w-{{ column.width }}"
                    sortable="{{ column.key }}"
                    (sort)="onSort($event)"
                  >
                    {{ column.label | translate }}
                  </th>
                </ng-container>
                <th>{{ "admin.campaigns.pipeline.status" | translate }}</th>
                <th>{{ "admin.campaigns.pipeline.creationDate" | translate }}</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody *ngIf="!loading">
              <tr *ngFor="let adCampaign of advertisingCampaign; let j = index">
                <ng-template #none>
                  <td>
                    {{ "undefined" | translate }}
                  </td>
                </ng-template>
                <td>
                  <a
                    type="button"
                    style="color: black"
                    [routerLink]="[
                      '/',
                      'dashboard',
                      'admin',
                      'campaigns',
                      'pipeline',
                      'statistics',
                      adCampaign.advertisingCampaignHashedId
                    ]"
                  >
                    <td>
                      {{ adCampaign.title }}
                    </td>
                  </a>
                </td>
                <td *ngIf="companyName[j]; else none">
                  {{ companyName[j] }}
                </td>
                <td *ngIf="adCampaign.objectiveName; else none">
                  {{ campaignObjective[adCampaign.objectiveName] | translate }}
                </td>
                <td *ngIf="adCampaign.locationPartners; else none">
                  <app-column-location-partners
                    [locationPartners]="adCampaign.locationPartners"
                    [j]="j"
                  ></app-column-location-partners>
                </td>
                <td *ngIf="adCampaign.startingDate; else none">
                  {{ adCampaign.startingDate | localizedDate }}
                </td>
                <td *ngIf="adCampaign.endingDate; else none">
                  {{ adCampaign.endingDate | localizedDate }}
                </td>
                <td *ngIf="adCampaign.status; else none">
                  <span
                    [ngClass]="
                      'badge ' +
                      badgeService.getBadgeForAdvertisingCampaingStatus(
                        adCampaign.status
                      )
                    "
                  >
                    {{
                      "enumMapping.campaigns.status." + adCampaign.status
                        | translate
                    }}
                  </span>
                </td>
                <td *ngIf="adCampaign.createdBy; else none">
                  <span
                    [ngbTooltip]="adCampaign.createdBy ? tooltip : null"
                    placement="bottom"
                    [container]="'body'"
                    data-bs-toggle="tooltip"
                  >
                    {{ adCampaign.publishDate | localizedDate }}
                  </span>

                  <ng-template #tooltip>
                    <div>
                      {{
                        ("advertisingCampaign.createBy" | translate) +
                          " " +
                          adCampaign.createdBy +
                          " " +
                          ("advertisingCampaign.on" | translate) +
                          " " +
                          (adCampaign.publishDate | localizedDate : "short")
                      }}
                    </div>
                  </ng-template>
                </td>
                <td>
                  <app-drop-zone-options
                    [options]="getOptions(adCampaign)"
                    (optionSelected)="saveAction($event, adCampaign)"
                  ></app-drop-zone-options>
                </td>
              </tr>
            </tbody>
          </table>
          <div *ngIf="forbidden" class="d-flex justify-content-center m-t-20">
            {{ "response.error.FORBIDDEN_RESPONSE" | translate }}
          </div>
          <div
            *ngIf="count == 0 && !loading && !forbidden"
            class="d-flex justify-content-center m-t-20"
          >
            {{ "noData" | translate }}
          </div>
          <div *ngIf="loading && !forbidden">
            <ng-container style="float: right" class="flex">
              <div class="loader-box">
                <div class="loader-34"></div>
              </div>
              <h6
                class="col align-self-center f-w-600"
                style="text-align: center"
              >
                {{ "fetching" | translate }}
              </h6>
            </ng-container>
          </div>
        </form>
      </div>
      <app-pager
        id="pager"
        [count]="count"
        [pageSize]="pageSize"
        [pageNumber]="pageNumber"
        (emitChangePage)="changePage($event)"
        (emitChangePageSize)="itemsPerPageChange($event)"
        for="announcersTable"
      ></app-pager>
    </div>
  </div>
</div>
